import { useEffect, useState } from 'react';
import { Link, useLocation, useSearchParams } from "react-router-dom";
import { Appointment, getLastThreePastAppointments, getUserAuthTokenForMeeting } from '../../data/appointments';

export function PreSession() {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("sessionId");
  const menteeName = searchParams.get("menteeName");

  const { appointment } = useLocation().state || {};

  const [authToken, setAuthToken] = useState('');

  const [pastAppointments, setPastAppointments] = useState<Appointment[]>([]);

  useEffect(() => {
    if (sessionId) {
      getUserAuthTokenForMeeting(sessionId, "mentor").then((authToken) => {
        setAuthToken(authToken);
      });

      getLastThreePastAppointments().then((appointments) => {
        setPastAppointments(appointments);
      });
    }
  }, [sessionId, menteeName]);

  const getMeetingDate = (appointment: Appointment) => {
    if (appointment) {
      const appointmentDate = new Date(appointment.dateTime);
      
      const day = appointmentDate.getDate();
      const month = appointmentDate.toLocaleString('default', { month: 'long' });
      const time = appointmentDate.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });

      return `${month} ${day} at ${time}`;
    }

    return "";
  };


  return (
    <div className="max-w-6xl mx-auto mt-10">
      <div className="bg-white rounded-lg p-6">
        <h1 className="text-3xl font-bold mb-3">
          Get Ready for Your Meeting with {menteeName}
        </h1>
        <div className="flex flex-col">
          <p className="text-lg text-black-600">
            {`Your meeting is scheduled for ${getMeetingDate(appointment)}. You can use this space to prepare.`}
          </p>
        </div>
        <div className="flex gap-12 mx-auto mt-10">
          <div className="w-1/2 bg-black-50 rounded-lg">
            <div className="flex flex-col gap-6">
              <div className="space-y-4">
                <h2 className="text-2xl font-bold text-black-800">
                  {pastAppointments[1] ? `Last Meeting: ${getMeetingDate(pastAppointments[1])}` : "This is your first session!" }
                </h2>
                <p className="text-black-600">
                  {pastAppointments[1] && pastAppointments[1].feedback}
                </p>
                {pastAppointments[1] && <div>
                  <p className="text-lg font-bold mb-2">Action Items</p>
                  <ul className="space-y-2">
                    <li className="flex items-center">
                      <input type="checkbox" className="mr-3 h-4 w-4" />
                      <span>Suggest Brown's book to {menteeName}.</span>
                    </li>
                  </ul>
                </div>}
              </div>
              <div className="space-y-3">
                {pastAppointments.slice(1).length > 0 && (
                  <>
                    <h2 className="text-2xl font-bold text-black-800">
                      Previous Meetings
                    </h2>
                    {pastAppointments.slice(2).length > 0 ? pastAppointments.slice(2).map((appointment) => (
                      <ul key={`appappointment-${appointment.id}`} className="space-y-2 text-black-600">
                        <li key={appointment.id}>{getMeetingDate(appointment)}</li>
                      </ul>
                    )) : null}
                  </>
                )}
                
              </div>
            </div>
          </div>
          <div className="w-1/2 bg-black-50 rounded-lg">
            <h2 className="text-2xl font-bold text-black-800 mb-6">
              Resources
            </h2>
            <div className="space-y-6">
              <div>
                <h3 className="text-xl font-semibold mb-3 text-black-700">
                  Resources You Shared
                </h3>
                <ul className="list-disc pl-5 space-y-3 text-black-600">
                  <li>Book: "The Power of Vulnerability" by Brené Brown</li>
                  <li>
                    Video: "Having Difficult Conversations at Work" - Harvard
                    Business Review
                  </li>
                </ul>
              </div>
              <div>
                <h3 className="text-xl font-semibold mb-3 text-black-700">
                  Resources {menteeName} Used
                </h3>
                <ul className="list-disc pl-5 space-y-3 text-black-600">
                  <li>
                    Workshop: "Effective Communication with Your Manager" -
                    Career Development Series
                  </li>
                  <li>
                    Article: "5 Ways to Build Trust with Your Boss" - Forbes
                    Leadership
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="flex justify-center gap-4 mt-10">
          <Link to={`/mentor/session?sessionId=${sessionId}&authToken=${authToken}`} state={{ appointment }}>
            <button className="bg-[#4CAF50] text-white px-6 py-3 rounded-full font-semibold hover:bg-[#45A049] transition-colors">
              Start Meeting
            </button>
          </Link>
          <button className="bg-green-200 text-black px-6 py-3 rounded-full hover:bg-green-600 transition-colors">
            Add Notes
          </button>
        </div>
      </div>
    </div>
  );
}
